<template>
  <div id="sig-container" class="full form-horizontal">
    <form @submit.prevent="guardarGestion" @keypress.enter.prevent="guardarGestion">
      <div class="loader" v-if="loading">
        <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
      </div>
      <contacto />
      <div class="widget nueva-gestion">
        <div class="widget-content widget-content-mini themed-background-dark-default text-light">Gestión
          {{hora_inicio}}</div>
        <div class="widget-content border-bottom themed-background-muted text-center">
          <div class="container">
            <div class="row mt-2" v-bind:class="{'has-error': errors?errors.tipo:false}">
              <label for class="col-3 control-label text-right">
                <strong>Tipo</strong>
              </label>
              <div class="col-4">
                <select name="tipo" v-model="tipo" class="form-control">
                  <option :value="null" disabled>Seleccione ...</option>
                  <option v-for="tipo in tipos" :key="tipo.id" :value="tipo">{{ tipo.descripcion }}</option>
                </select>
                <span class="help-block" v-if="errors?errors.tipo:false">{{ errors?errors.tipo[0]:'' }}</span>
              </div>
              <label for class="col-1 control-label text-right">
                <strong>Subtipo</strong>
              </label>
              <div class="col-4">
                <select name="subtipo" v-model="subtipo" class="form-control">
                  <option :value="null" disabled>Seleccione ...</option>
                  <option v-for="subtipo in _subtipos" :key="subtipo.id" :value="subtipo">{{ subtipo.descripcion }}
                  </option>
                </select>
                <span class="help-block" v-if="errors?errors.sub_tipo_gestion_id:false">{{
                  errors?errors.sub_tipo_gestion_id[0]:'' }}</span>
              </div>
            </div>

            <div class="row mt-2"
              v-bind:class="{'has-error': (errors?errors.sub_tipo_gestion_id?true:false:false && !sub_tipo_gestion_id)?true:false}">
            </div>
            <div class="row mt-2" v-bind:class="{'has-error': errors?errors.observacion:false}">
              <label for class="col-3 control-label text-right">
                <strong>Observación</strong>
              </label>
              <div class="col-9">
                <textarea name="observacion" v-model="observacion" class="form-control" cols="30" rows="2"></textarea>
                <span class="help-block" v-if="errors?errors.observacion:false">{{ errors?errors.observacion[0]:''
                  }}</span>
              </div>
            </div>
            <div class="row mt-2" v-bind:class="{'has-error': errors?errors.causal_mora_id:false}">
              <label for class="col-3 control-label text-right">
                <strong>Causal Mora</strong>
              </label>
              <div class="col-4">
                <select name v-model="causal_mora_id" class="form-control">
                  <option :value="null" disabled>Seleccione ...</option>
                  <option v-for="(causal_mora, index) in causales_mora" :key="index" :value="causal_mora.id">{{
                    causal_mora.descripcion }}</option>
                </select>
                <span class="help-block" v-if="errors?errors.causal_mora_id:false">{{ errors?errors.causal_mora_id[0]:''
                  }}</span>
              </div>

              <label for class="col-1 control-label text-right">
                <strong>Origen:</strong>
              </label>
              <div class="col-4">
                <select name v-model="origen" class="form-control">
                  <option :value="null" disabled>Seleccione ...</option>
                  <option :value="'Llamada entrante'">Llamada Entrada</option>
                  <option :value="'Llamada saliente'">Llamada Salida</option>
                  <option :value="'SMS'">SMS</option>
                  <option :value="'Email'">Email</option>
                  <option :value="'IVR'">IVR</option>
                  <option :value="'Whatsapp entrada'">WhatsApp Entrada</option>
                  <option :value="'Whatsapp salida'">WhatsApp Salida</option>
                </select>
              </div>
            </div>
            <div class="row mt-2" v-bind:class="{'has-error': errors?errors.telefono:false}"
              v-if="origen == 'Whatsapp entrada' || origen == 'Whatsapp salida'">
              <label for class="col-3 control-label text-right">
                <strong>Tel/Cel:</strong>
              </label>
              <div class="col-4 d-flex align-items-center justify-content-between">
                <input type="text" class="form-control" id="telefono_whatsapp" v-model="gestion.telefono">
                <font-awesome-icon class="text-danger mx-1"
                  v-tooltip.top="'Por favor indique el número de celular desde donde se originó la gestión.'"
                  :icon="['fa', 'exclamation-circle']" />
              </div>
              <div class="col-4">
              </div>
            </div>
            <div class="row mt-2" v-bind:class="{'has-error': errors?errors.gestion_obligacion:false}">
              <label for class="col-3 control-label text-right">
                <strong>Obligaciones</strong>
              </label>
              <div class="col-9">
                <div class="row">
                  <div class="col-2">
                    <strong>Obligación</strong>
                  </div>
                  <div class="col-2">
                    <strong>Intermediario Financiero</strong>
                  </div>
                  <div class="col-2">
                    <strong>Saldo Capital</strong>
                  </div>
                  <div class="col-2">
                    <strong>Intereses</strong>
                  </div>
                  <div class="col-2">
                    <strong>Total</strong>
                  </div>
                  <div class="col-2 alert-info text-white"
                    v-tooltip.top="'El interes diario es el 0.05% sobre el saldo capital de la obligación antes de intereses del intermediario, otros gastos, adiciones e intereses FGA.'">
                    <strong>Intereses Diarios</strong>
                  </div>
                </div>
                <div class="row" v-for="obligacion in obligaciones" :key="obligacion.id">
                  <div class="col-2 text-left">
                    <b-checkbox v-model="gestion_obligacion" @input="recalcular_monto_congelar"
                      :native-value="obligacion" :class="'csscheckbox csscheckbox-info'"
                      v-bind:disabled="(obligacion.nit != $store.state.user.user.casa_cobranza.nit) || (obligacion.informacion_adicional.bloqueo_gestion === true) || (obligacion.condonacion_obligacion.length > 0 && ! usuario_condonacion)">
                      {{ obligacion.identificador_obligacion }}
                      <font-awesome-icon
                        v-if="(obligacion.nit != $store.state.user.user.casa_cobranza.nit) || (obligacion.informacion_adicional.bloqueo_gestion === true) || (obligacion.condonacion_obligacion.length > 0 && ! usuario_condonacion)"
                        class="text-danger mx-1"
                        :icon="['fa', 'exclamation-circle']"
                        @click="abrirModal((obligacion.nit != $store.state.user.user.casa_cobranza.nit), (obligacion.informacion_adicional.bloqueo_gestion === true) , (obligacion.condonacion_obligacion.length > 0 && ! usuario_condonacion), obligacion.observaciones)"
                        />
                    </b-checkbox>
                  </div>
                  <div class="col-2 text-left">{{banco_abr(obligacion.informacion_adicional)}}</div>
                  <div class="col-2 text-right">{{ obligacion.saldo_capital | numberFormat }}</div>
                  <div class="col-2 text-right">{{ obligacion.interes_fga | numberFormat }}</div>
                  <div class="col-2 text-right">{{ obligacion.interes_fga+obligacion.saldo_capital | numberFormat }}
                  </div>
                  <div class="col-2 text-right alert-info text-white"
                    v-tooltip.top="'Esta información no hace parte del saldo de la obligación y solo puede ser utilizada para el proceso de negociación'">
                    {{ obligacion.informacion_adicional.saldo_capital*0.0005 | numberFormat }}</div>
                </div>
                <div class="row">
                  <div class="col-2 offset-4 text-right" style="border-top:1px solid">{{ obligaciones.map(o =>
                    o.saldo_capital).reduce((prev, next) => prev + next) | numberFormat }}</div>
                  <div class="col-2 text-right" style="border-top:1px solid">{{ obligaciones.map(o =>
                    o.interes_fga).reduce((prev, next) => prev + next) | numberFormat }}</div>
                  <div class="col-2 text-right" style="border-top:1px solid">{{ obligaciones.map(o =>
                    o.interes_fga+o.saldo_capital).reduce((prev, next) => prev + next) | numberFormat }}</div>
                  <div class="col-2 text-right alert-info text-white" style="border-top:1px solid"
                    v-tooltip.top="'Esta información no hace parte del saldo de la obligación y solo puede ser utilizada para el proceso de negociación'">
                    {{ obligaciones.map(o => (o.informacion_adicional.saldo_capital*0.0005)).reduce((prev, next) => prev
                    + next) | numberFormat }}</div>
                </div>
                <span class="help-block" v-if="errors?errors.gestion_obligacion:false">{{
                  errors?errors.gestion_obligacion[0]:'' }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="widget mt-3" v-if="sub_tipo_gestion_id == '25'">
          <div class="widget-content widget-content-mini themed-background-dark-default text-light">Acuerdos de Pago -
            Abonando</div>
          <div class="widget-content border-bottom themed-background-muted text-center">
            <div class="container">
              <div class="row mt-2">
                <label for class="col-2 control-label text-right">
                  <strong>Fecha primer pago</strong>
                </label>
                <div class="col-3 text-left">
                  <datepicker v-model="fecha_primer_pago" :format="'yyyy-MM-dd'" :input-class="'form-control'"
                    :placeholder="'Fecha Primer Pago'"></datepicker>
                </div>
                <label for class="col-2 control-label text-right">
                  <strong>Día de pago</strong>
                </label>
                <div class="col-md-4">
                  <select name v-model="dia_pago" class="form-control">
                    <option selected :value="null" disabled>Seleccione...</option>
                    <option v-for="(n, index) in 31" :key="index" :value="n">{{ n }}</option>
                  </select>
                </div>
                <label for class="col-2 control-label text-right">
                  <strong>Valor compromiso</strong>
                </label>
                <div class="col-3 text-left">
                  <input type="text" v-model.number="valor_compromiso" id="valor_compromiso" class="form-control"
                    placeholder="Valor compromiso" />
                </div>
              </div>
              <div class="row mt-2" v-bind:class="{'has-error': errors?errors['acuerdo_pago.0']:false}">
                <div class="col-9 offset-3">
                  <span class="help-block" v-if="errors?errors['acuerdo_pago.0']:false">{{
                    errors?errors['acuerdo_pago.0'][0]:'' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="widget mt-3" v-if="sub_tipo_gestion_id == '6' || sub_tipo_gestion_id == '12'">
          <div class="widget-content widget-content-mini themed-background-dark-default text-light">Acuerdos de Pago
          </div>
          <div class="widget-content border-bottom themed-background-muted text-center">
            <div class="container">
              <div class="row mt-2">
                <label for class="col-3 control-label text-right">
                  <strong>Fecha primer pago</strong>
                </label>
                <div class="col-4">
                  <datepicker v-model="fecha_primer_pago" :format="'yyyy-MM-dd'" :input-class="'form-control'"
                    :placeholder="'Fecha Primer Pago'"></datepicker>
                </div>
                <label for class="col-2 control-label text-right">
                  <strong>Día de pago</strong>
                </label>
                <div class="col-md-3">
                  <select name v-model="dia_pago" class="form-control">
                    <option selected :value="null" disabled>Seleccione...</option>
                    <option v-for="(n, index) in 31" :key="index" :value="n">{{ n }}</option>
                  </select>
                </div>
              </div>
              <div class="row mt-2">
                <label for class="col-3 control-label text-right">
                  <strong>Monto a congelar</strong>
                </label>
                <div class="col-4 text-left">
                  <input type="text" v-model.number="monto_congelar" id="monto_congelar" class="form-control"
                    placeholder="Monto a congelar" />
                </div>
                <label for class="col-2 control-label text-right">
                  <strong>Valor cuota inicial</strong>
                </label>
                <div class="col-3 text-left">
                  <input type="text" v-model.number="valor_cuota_inicial" id="valor_cuota_inicial" class="form-control"
                    placeholder="Valor primera cuota" />
                </div>
              </div>
              <div class="row mt-2">
                <label for class="col-3 control-label text-right">
                  <strong>Número de cuotas</strong>
                </label>
                <div class="col-4">
                  <div class="row">
                    <div class="col-9" v-if="!this.check_insolvencia">
                      <select name v-model.number="cuotas" class="form-control">
                        <option :value="null" selected disabled>Seleccione...</option>
                        <option v-for="(n, index) in numero_maximo_cuotas" :key="index" :value="n">{{ n }}</option>
                      </select>
                    </div>
                    <div class="col-9" v-if="this.check_insolvencia">
                      <input type="text" v-model="cuotas" id="cuotas_text" class="form-control"
                    placeholder="Número de cuotas" />
                    </div>
                    <div class="col-3 text-center">
                      <btn type="info"
                        v-tooltip.top="'Calcular el número de cuotas a partir del monto congelado y el valor de la cuota que desea pagar'"
                        @click="simular('numero_cuotas')">
                        <font-awesome-icon :icon="'calculator'"></font-awesome-icon>
                      </btn>
                    </div>
                  </div>
                </div>
                <label for class="col-2 control-label text-right">
                  <strong>Valor Cuota</strong>
                </label>
                <div class="col-3 text-left">
                  <div class="row">
                    <div class="col-9">
                      <input type="text" v-model.number="valor_cuota" id="valor_cuota" :min="valor_cuota_minima"
                        class="form-control" v-bind:class="{ 'is-invalid': (valor_cuota<valor_cuota_minima) }"
                        placeholder="Valor Cuota" />
                    </div>
                    <div class="col-3">
                      <btn type="info"
                        v-tooltip.top="'Calcular el valor de la cuota teniendo en cuenta el plazo en el que desea diferir el monto a congelar menos el valor de la cuota inicial'"
                        @click="simular('valor_cuota')">
                        <font-awesome-icon :icon="'calculator'"></font-awesome-icon>
                      </btn>
                    </div>
                  </div>
                </div>


                <label v-if="condonacion && usuario_condonacion" class="col-3 control-label text-right">
                  <strong>Saldo a descontar de capital</strong>
                </label>
                <div v-if="condonacion && usuario_condonacion" class="col-4 text-left">
                  <div class="row">
                    <div class="col-9">
                      <input type="text" :value="condonacion_capital" id="valor_cuota" :disabled="true"
                        class="form-control" />
                    </div>
                  </div>
                </div>
                <label v-if="condonacion && usuario_condonacion" class="col-2 control-label text-right">
                  <strong>Porcentaje descuento de capital</strong>
                </label>
                <div v-if="condonacion && usuario_condonacion" class="col-3 text-left">
                  <div class="row">
                    <div class="col-9">
                      <input type="number" id="porcentaje_condonacion" :min="0" :max="altura.porcentaje"
                        v-model="porcentaje_condonacion_capital" v-on="validarPorcentaje()" step="0.01"
                        class="form-control" />
                    </div>
                  </div>
                </div>

                <label v-if="condonacion && usuario_condonacion" class="col-3 control-label text-right">
                  <strong>Total con descuento de capital</strong>
                </label>
                <div v-if="condonacion && usuario_condonacion" class="col-4 text-left">
                  <div class="row">
                    <div class="col-9">
                      <input type="text" :value="monto_congelar - condonacion_capital" id="valor_cuota" :disabled="true"
                        class="form-control" />
                    </div>
                  </div>
                </div>

              </div>
              <div class="row mt-2">
                <label v-if="this.insolvencia" class="col-3 control-label text-right">
                  <strong>Insolvencia</strong>
                </label>
                <div v-if="this.insolvencia" class="col-4 text-left">
                  <div class="row">
                    <div class="col-9">
                      <b-checkbox :class="'csscheckbox csscheckbox-info'" v-model="check_insolvencia"></b-checkbox>
                    </div>
                  </div>
                </div>
                </div>
              <div class="row mt-2" v-bind:class="{'has-error': errors?errors['acuerdo_pago.0']:false}">
                <div class="col-9 offset-3">
                  <span class="help-block" v-if="errors?errors['acuerdo_pago.0']:false">{{
                    errors?errors['acuerdo_pago.0'][0]:'' }}</span>
                </div>
              </div>



              <div class="col p-2 text-center alert-warning"
                v-if="!estado_acuerdo && valor_cuota!= null && valor_cuota != 0 && this.insolvencia && this.check_insolvencia">
                <b>
                  <font-awesome-icon :icon="'times'" class="mx-2"></font-awesome-icon>Existen errores en el acuerdo de
                  pago. No se cumple la regla.
                </b>
              </div>
              <div class="col p-2 text-center alert-success"
                v-if="estado_acuerdo && validar_monto_congelar && valor_cuota!= null && valor_cuota != 0">
                v-if="estado_acuerdo && valor_cuota!= null && valor_cuota != 0 && this.insolvencia && this.check_insolvencia">
                <b>
                  <font-awesome-icon :icon="'check'" class="mx-2"></font-awesome-icon>Habilitado para registrar insolvencias economicas
                </b>
              </div>
              <div class="col p-2 text-center alert-success"
                v-if="estado_acuerdo && valor_cuota!= null && valor_cuota != 0 && (!this.insolvencia || !this.check_insolvencia)">
                <b>
                  <font-awesome-icon :icon="'check'" class="mx-2"></font-awesome-icon>El acuerdo está bien calculado
                </b>
              </div>
              <div class="col p-2 text-center alert-danger"
                v-if="!estado_acuerdo && valor_cuota!= null && valor_cuota != 0 && (!this.insolvencia || !this.check_insolvencia)">
                <b>
                  <font-awesome-icon :icon="'times'" class="mx-2"></font-awesome-icon>Existen errores en el acuerdo de
                  pago. No se cumple la regla.
                </b>
              </div>

              <div class="col p-3 text-justify">
                <h3>Formula para calcular el monto congelado:</h3>
                <p>Monto Congelado = (Valor de la cuota * Numero de Cuotas ) + Valor de la cuota inicial.</p>

                <h3 v-if="condonacion && usuario_condonacion">Formula para calcular el saldo maximo a condonar:</h3>
                <p v-if="condonacion && usuario_condonacion">{{"Condonación capital = (Saldo capital *" +
                  altura.porcentaje + "% )"}}</p>

                <p>
                  <b>Nota:</b>
                <ul>
                  <li>La cuota inicial no se cuenta como una Cuota adicional.</li>
                  <li>El número máximo de cuotas es <b>{{numero_maximo_cuotas}}</b></li>
                  <li>El valor mínimo de una cuota es <b>{{valor_cuota_minima | numberFormat }}</b></li>
                </ul>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="validacionAcuerdo">
          <div class="col p-2 text-center alert-danger">
            <b>
              <font-awesome-icon :icon="'times'" class="mx-2"></font-awesome-icon>Las obligaciones seleccionadas tienen
              algún acuerdo de pago vigente
            </b>
          </div>
          <table-component :data="acuerdosxobligaciones" pagination>
            <table-column slot="label" :label="'ID'" v-bind:value="'id'"></table-column>
            <table-column slot="label" :label="'obligacion'" v-bind:value="'codigo'"></table-column>
            <table-column slot="label" :label="'Fecha de Llamada'" v-bind:value="'hora_inicio'"
              :filter="'formatDate'"></table-column>
            <table-column slot="label" :label="'Fecha Primer Pago'" v-bind:value="'fecha_primer_pago'"></table-column>
            <table-column slot="label" :label="'Dia de Pago'" v-bind:value="'dia_pago'"></table-column>
            <table-column slot="label" :label="'Cuotas'" v-bind:value="'cuotas'"
              :customClass="'text-right'"></table-column>
            <table-column slot="label" :label="'Valor cuota'" v-bind:value="'valor_cuota'" :filter="'numberFormat'"
              :customClass="'text-right'"></table-column>
            <table-column slot="label" :label="'Valor cuota inicial'" v-bind:value="'valor_cuota_inicial'"
              :filter="'numberFormat'" :customClass="'text-right'"></table-column>
            <table-column slot="label" :label="'Monto Congelado'" v-bind:value="'monto_congelar'"
              :filter="'numberFormat'" :customClass="'text-right'"></table-column>
            <table-column slot="label" :label="'Tipo de acuerdo'" v-bind:value="'tipo'"></table-column>
            <table-column slot="label" :label="'Estado'" v-bind:value="'estado'"></table-column>
            <table-column slot="label" :label="'Usuario modificación'" v-bind:value="'username'"></table-column>
            <table-column slot="label" :label="'Saldo condonado'" v-bind:value="'condonacion_capital'"></table-column>
          </table-component>
        </div>

        <div class="widget mt-3" v-if="sub_tipo_gestion_id == '32'">
          <div class="widget-content widget-content-mini themed-background-dark-default text-light">PQRS</div>
          <div class="widget-content border-bottom themed-background-muted text-center">
            <div class="container">
              <div class="row mt-2">
                <label for class="col-3 control-label text-right">
                  <strong>Asunto</strong>
                </label>
                <div class="col-4">
                  <input type="text" v-model="asunto_pqrs" class="form-control" />
                </div>

                <label for class="col-1 control-label text-right">
                  <strong>Tipo</strong>
                </label>
                <div class="col-4">
                  <select v-model="tipo_pqrs" class="form-control">
                    <option selected :value="null" disabled>Seleccione...</option>
                    <optgroup label="Petición">
                      <!-- <option value="24">¿Qué me están cobrando?</option> -->
                      <option value="42">Derecho de petición</option>
                      <!-- <option value="29">Otro</option> -->
                    </optgroup>
                    <optgroup label="Queja">
                      <option value="30">Inconformidad por el servicio (Deudores)</option>
                      <!-- <option value="31">Otro</option> -->
                    </optgroup>
                    <optgroup label="Reclamo">
                      <option value="28">Actualización, rectificación o eliminación de reportes en centrales de
                        información</option>
                      <!-- <option value="32">Inconvenientes acuerdo de pago</option> -->
                      <!-- <option value="33">Notificación de fraude o suplantación</option> -->
                      <!-- <option value="34">Otro</option> -->
                    </optgroup>

                    <optgroup label="Sugerencia">
                      <option value="41">Sugerencia</option>
                    </optgroup>
                    <!-- <optgroup label="Recurso">
                      <option value="39">Recurso</option>
                    </optgroup> -->
                    <!-- <optgroup label="Solicitud General">
                      <option value="35">Información de FGA Fondo de Garantías</option>
                      <option value="36">Información del servicio de CDT's</option>
                      <option value="37">Solicitudes de entes gubernamentales</option>
                      <option value="38">Otro</option>
                    </optgroup> -->
                  </select>
                </div>
              </div>
              <div class="row mt-2">
                <label for class="col-3 control-label text-right">
                  <strong>Correo de notificación</strong>
                </label>
                <div class="col-4">
                  <select v-model="correo_notificacion" class="form-control">
                    <option selected :value="null" disabled>Seleccione...</option>
                    <option v-for="email in contactos.email" v-bind:key="email.id" :value="email.valor">{{email.valor}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col">
                  <div class="card">
                    <div class="card-header">
                      Resumen de la PQRS
                    </div>
                    <div class="card-body text-justify" v-html="descripcion_caso">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="widget mt-3" v-if="sub_tipo_gestion_id == '34'">
          <div class="widget-content widget-content-mini themed-background-dark-default text-light">PQRS</div>
          <div class="widget-content border-bottom themed-background-muted text-center">
            <div class="container">
              <div class="row mt-2">
                <label for class="col-3 control-label text-right">
                  <strong>Asunto</strong>
                </label>
                <div class="col-4">
                  <input type="text" v-model="asunto_pqrs" class="form-control" />
                </div>

                <label for class="col-1 control-label text-right">
                  <strong>Tipo</strong>
                </label>
                <div class="col-4">
                  <select v-model="tipo_pqrs" class="form-control">
                    <option selected :value="null" disabled>Seleccione...</option>
                    <optgroup label="Solicitud de documentos">
                      <!-- <option value="25">Quiero hacer un acuerdo de pago.</option> -->
                      <option value="27">¿Cuánto debo?</option>
                      <option value="26">Necesito el paz y salvo de mi deuda</option>
                      <option value="43">Necesito el certificado de mi deuda</option>
                      <option value="81">Necesito el certificado tributario</option>
                    </optgroup>
                  </select>
                </div>
              </div>
              <div class="row mt-2">
                <label for class="col-3 control-label text-right">
                  <strong>Correo de notificación</strong>
                </label>
                <div class="col-4">
                  <select v-model="correo_notificacion" class="form-control">
                    <option selected :value="null" disabled>Seleccione...</option>
                    <option v-for="email in contactos.email" v-bind:key="email.id" :value="email.valor">{{email.valor}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col">
                  <div class="card">
                    <div class="card-header">
                      Resumen de la solicitud
                    </div>
                    <div class="card-body text-justify" v-html="descripcion_caso">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6 offset-md-3 text-center mt-3">
          <button type="button" @click="guardarGestion('guardar')" class="m-1 btn btn-sm btn-info"
            :disabled="buttonDisabled || saving">
            <span v-if="saving">
              <font-awesome-icon :icon="'sync'"></font-awesome-icon>Guardando...
            </span>
            <span v-else>{{validacionAcuerdo ? "Cancelar acuerdos anteriores y guardar" : "Guardar"}}</span>
          </button>
          <button type="button" class="m-1 btn btn-sm btn-danger" :disabled="buttonDisabled || saving"
            @click="guardarGestion('guardar_y_cerrar')">Guardar y Colgar</button>
          <button type="button" @click="inicializarVariablesGestion" class="m-1 btn btn-sm btn-warning">Limpiar</button>
        </div>
      </div>
      <notificador />
    </form>
    <modal
      class="modal fade"
      v-model="modal"
      ref="modal-password"
      id="modal-password"
    >
      <template>
        <div class="loader" v-if="false">
          <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
        </div>
        <template slot="header">
          <h4 class="modal-title">Información bloqueo</h4>
          <button
            type="button"
            aria-label="Close"
            class="close"
            style="position: relative; z-index: 1060"
            @click="cerrarModal()"
          >
          </button>
        </template>
        <h4>{{ mensaje_bloqueo }}</h4>
        <template slot="footer">
          <btn
            type="button"
            class="btn btn-danger"
            @click="cerrarModal()"
            >Cerrar</btn>
        </template>
      </template>
    </modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import causal_mora from "@/data/causal_mora.json";
import Datepicker from "vuejs-datepicker";
import FileSaver from "file-saver";
import axios from "axios";

// Interceptar todas las solicitudes HTTP y manejar las CORS antes de enviarlas
axios.interceptors.request.use(
  function (config) {
    if (config.method === "POST") {
      config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    }
    console.log("113", config.method, config);
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default {
  name: "Gestion",
  data: () => {
    return {
      modal: false,
      mensaje_bloqueo: "",
      hora_inicio: "",
      acuerdosxobligaciones: [],
      validacionAcuerdo: false,
      gestion: {
        gestion_obligacion: [],
        acuerdo_pago: [],
        causal_mora_id: null,
        telefono: null,
      },
      estado: "vigente",
      causales_mora: causal_mora,
      errors: null,
      n: 1,
      numero_maximo_cuotas: 100,
      valor_cuota_minima: 10000,
      miles_a_redondear: 100,
      saving: false,
      condonacion: false,
      usuario_condonacion: false,
      insolvencia: false,
      check_insolvencia: false,
      altura: {
        porcentaje: null,
      },
      monto_condonar: null,
      monto_max_condonar: 0,
      condonacion_capital: 0,
      porcentaje_condonacion_capital: 0,
      sub_tipo_gestion_name: "",
      observacionGocontact: "",
    };
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      deudor: "deudor/deudor",
      obligaciones: "deudor/obligaciones",
      tipos: "tiposSubtipos/tipos",
      subtipos: "tiposSubtipos/subtipos",
      datosGestion: "gestion/datosGestion",
      contactos: "gestion/infoContacto",
    }),
    acuerdos_pago() {
      return this.$store.getters["deudor/acuerdos_pago"];
    },
    _subtipos() {
      if (!this.tipo) {
        return [];
      } else {
        return this.subtipos.filter(
          (subtipo) => subtipo.tipo_gestion_id == this.tipo.id
        );
      }
    },
    buttonDisabled() {
      if (this.observacion == "") {
        return true;
      }
      if (this.causal_mora_id == null) {
        return true;
      }
      if (this.subtipo == null) {
        return true;
      }

      if (this.origen == null) {
        return true;
      }

      if (
        (this.origen == "Whatsapp entrada" ||
          this.origen == "Whatsapp salida") &&
        (this.gestion.telefono == "" || this.gestion.telefono == null)
      ) {
        return true;
      }

      if (
        this.gestion_obligacion == null ||
        this.gestion_obligacion == undefined ||
        this.gestion_obligacion.length == 0
      ) {
        return true;
      }

      // Validamos si es un acuerdo de Pago
      if (
        this.subtipo != null &&
        (this.subtipo.id == 6 || this.subtipo.id == 12)
      ) {
        if (
          this.fecha_primer_pago == undefined ||
          this.fecha_primer_pago == null
        ) {
          return true;
        }

        if (this.insolvencia && this.check_insolvencia) {
          return false;
        }

        if (!this.estado_acuerdo) {
          return true;
        }

        let valor_minimo = this.gestion_obligacion.reduce(
          (a, b) => a + (b["saldo_capital"] || 0),
          0
        );

        // let valor_maximo = this.gestion_obligacion.reduce(
        //   (a, b) => a + (b["saldo_capital"] + b["interes_fga"]  || 0),
        //   0
        // )
        if (this.monto_congelar + this.valor_cuota_inicial < valor_minimo) {
          return true;
        }

        // if (this.monto_congelar > valor_maximo) {
        //   return true;
        // }

        if (
          this.gestion_obligacion.reduce((a, b) => a + b.saldo_real, 0) >
            this.valor_cuota_minima &&
          this.valor_cuota < this.valor_cuota_minima
        ) {
          return true;
        }

        if (this.cuotas && this.cuotas > this.numero_maximo_cuotas) {
          return true;
        }

        if (this.dia_pago == null || this.dia_pago <= 0 || this.dia_pago > 31) {
          return true;
        }
      }

      // Validamos si está abonando

      if (this.subtipo != null && this.subtipo.id == 25) {
        if (
          this.valor_compromiso == null ||
          isNaN(this.valor_compromiso) ||
          this.valor_compromiso <= 0 ||
          this.fecha_primer_pago == undefined ||
          this.fecha_primer_pago == null
        ) {
          return true;
        }
        if (this.dia_pago == null || this.dia_pago < 1 || this.dia_pago > 31) {
          return true;
        }
      }

      // Validamos si es una PQRS

      if (this.subtipo != null && this.subtipo.id == 32) {
        if (this.asunto_pqrs == null || this.asunto_pqrs == "") {
          return true;
        }
        if (this.tipo_pqrs == null) {
          return true;
        }
        if (this.correo_notificacion == null) {
          return true;
        }
      }

      // Validamos si es una soliciutd de documentos
      if (this.subtipo != null && this.subtipo.id == 34) {
        if (this.asunto_pqrs == null || this.asunto_pqrs == "") {
          return true;
        }
        if (this.tipo_pqrs == null) {
          return true;
        }
        if (this.correo_notificacion == null) {
          return true;
        }
      }

      return false;
    },
    descripcion_caso() {
      let telefonos = "";
      if (
        typeof this.contactos.telefono == "object" &&
        this.contactos.telefono.length > 0
      ) {
        telefonos = this.contactos.telefono.reduce((a, b) => {
          a.push(b.valor);
          return a;
        }, []);
        telefonos = telefonos.join(" / ");
      }
      let direcciones = "";
      if (
        typeof this.contactos.direccion == "object" &&
        this.contactos.direccion.length > 0
      ) {
        direcciones = this.contactos.direccion.reduce((a, b) => {
          a.push(
            b.valor +
              (b.municipio != null
                ? " (" +
                  b.municipio.municipio +
                  " - " +
                  b.municipio.departamento +
                  ")"
                : "")
          );
          return a;
        }, []);
        direcciones = direcciones.join(" / ");
      }
      let emails = "";
      if (
        typeof this.contactos.email == "object" &&
        this.contactos.email.length > 0
      ) {
        emails = this.contactos.email.reduce((a, b) => {
          a.push(b.valor);
          return a;
        }, []);
        emails = emails.join(" / ");
      }

      return (
        "<p><b>Nombre y apellido: </b>" +
        this.deudor.nombre +
        "</br><b>Cédula: </b>" +
        this.deudor.identificacion +
        "</br><b>Teléfono: </b>" +
        telefonos +
        "</br><b>Email registrados: </b>" +
        emails +
        "</br><b>Correo de notificación: </b>" +
        this.correo_notificacion +
        "</br><b>Dirección: </b>" +
        direcciones +
        "</br><b>Asunto: </b>" +
        this.asunto_pqrs +
        "</br><b>Mensaje: </b>" +
        this.observacion
      );
    },
    asunto_pqrs: {
      get() {
        return this.datosGestion.pqrs.asunto;
      },
      set(value) {
        this.$store.commit("gestion/SET_DATOS_GESTION", {
          obj: "pqrs",
          key: "asunto",
          value: value,
        });
      },
    },
    tipo_pqrs: {
      get() {
        return this.datosGestion.pqrs.tipo_pqrs;
      },
      set(value) {
        this.$store.commit("gestion/SET_DATOS_GESTION", {
          obj: "pqrs",
          key: "tipo_pqrs",
          value: value,
        });
      },
    },
    correo_notificacion: {
      get() {
        return this.datosGestion.pqrs.correo_notificacion;
      },
      set(value) {
        this.$store.commit("gestion/SET_DATOS_GESTION", {
          obj: "pqrs",
          key: "correo_notificacion",
          value: value,
        });
      },
    },
    estado_acuerdo: {
      get() {
        return (
          this.monto_congelar ==
          this.valor_cuota_inicial +
            this.condonacion_capital +
            this.valor_cuota * this.cuotas
        );
      },
    },
    observacion: {
      get() {
        return this.datosGestion.gestion.observacion;
      },
      set(value) {
        this.$store.commit("gestion/SET_DATOS_GESTION", {
          obj: "gestion",
          key: "observacion",
          value: value,
        });
      },
    },
    tipo: {
      get() {
        return this.datosGestion.gestion.tipo;
      },
      set(value) {
        this.$store.commit("gestion/SET_DATOS_GESTION", {
          obj: "gestion",
          key: "tipo",
          value: value,
        });
      },
    },
    subtipo: {
      get() {
        this.sub_tipo_gestion_id =
          this.datosGestion.gestion.subtipo == null
            ? null
            : this.datosGestion.gestion.subtipo.id;
        return this.datosGestion.gestion.subtipo;
      },
      set(value) {
        this.$store.commit("gestion/SET_DATOS_GESTION", {
          obj: "gestion",
          key: "subtipo",
          value: value,
        });
      },
    },
    causal_mora_id: {
      get() {
        return this.datosGestion.gestion.causal_mora_id;
      },
      set(value) {
        this.$store.commit("gestion/SET_DATOS_GESTION", {
          obj: "gestion",
          key: "causal_mora_id",
          value: value,
        });
      },
    },
    origen: {
      get() {
        return this.datosGestion.gestion.origen;
      },
      set(value) {
        this.$store.commit("gestion/SET_DATOS_GESTION", {
          obj: "gestion",
          key: "origen",
          value: value,
        });
      },
    },
    gestion_obligacion: {
      get() {
        return this.datosGestion.gestion.gestion_obligacion;
      },
      set(value) {
        this.$store.commit("gestion/SET_DATOS_GESTION", {
          obj: "gestion",
          key: "gestion_obligacion",
          value: value,
        });
      },
    },
    fecha_primer_pago: {
      get() {
        return this.datosGestion.acuerdo_pago.fecha_primer_pago;
      },
      set(value) {
        this.$store.commit("gestion/SET_DATOS_GESTION", {
          obj: "acuerdo_pago",
          key: "fecha_primer_pago",
          value: value,
        });
      },
    },
    dia_pago: {
      get() {
        return this.datosGestion.acuerdo_pago.dia_pago;
      },
      set(value) {
        this.$store.commit("gestion/SET_DATOS_GESTION", {
          obj: "acuerdo_pago",
          key: "dia_pago",
          value: value,
        });
      },
    },
    monto_congelar: {
      get() {
        return this.datosGestion.acuerdo_pago.monto_congelar;
      },
      set(value) {
        this.$store.commit("gestion/SET_DATOS_GESTION", {
          obj: "acuerdo_pago",
          key: "monto_congelar",
          value: value,
        });
      },
    },
    valor_cuota_inicial: {
      get() {
        return this.datosGestion.acuerdo_pago.valor_cuota_inicial;
      },
      set(value) {
        this.$store.commit("gestion/SET_DATOS_GESTION", {
          obj: "acuerdo_pago",
          key: "valor_cuota_inicial",
          value: value,
        });
      },
    },
    cuotas: {
      get() {
        return this.datosGestion.acuerdo_pago.cuotas;
      },
      set(value) {
        this.$store.commit("gestion/SET_DATOS_GESTION", {
          obj: "acuerdo_pago",
          key: "cuotas",
          value: value,
        });
      },
    },
    valor_cuota: {
      get() {
        return this.datosGestion.acuerdo_pago.valor_cuota;
      },
      set(value) {
        this.$store.commit("gestion/SET_DATOS_GESTION", {
          obj: "acuerdo_pago",
          key: "valor_cuota",
          value: value,
        });
      },
    },
    valor_compromiso: {
      get() {
        return this.datosGestion.acuerdo_pago.valor_compromiso;
      },
      set(value) {
        this.$store.commit("gestion/SET_DATOS_GESTION", {
          obj: "acuerdo_pago",
          key: "valor_compromiso",
          value: value,
        });
      },
    },
  },
  components: {
    TableComponent: () => import("@@/components/table/TableComponent"),
    TableColumn: () => import("@@/components/table/TableColumn"),
    Contacto: () => import("@/views/Contacto.vue"),
    Notificador: () => import("@/views/Notificador.vue"),
    Datepicker,
  },
  methods: {
    recalcular_monto_congelar(value) {
      var total = 0;

      if (value.length > 0) {
        value.forEach((element) => {
          total += Number(element.saldo_real);
        });
      }

      if (
        value.length !== undefined &&
        value.length == 1 &&
        value[0].condonacion_obligacion.length > 0
      ) {
        total = value[0].saldo_capital;
        this.validar_condonacion(value);
      } else {
        this.condonacion = false;
        this.condonacion_capital = 0;
        this.monto_condonar = 0;
        this.monto_max_condonar = 0;
      }

      total =
        Math.ceil(total / this.miles_a_redondear) * this.miles_a_redondear;

      this.monto_congelar = total;
      return total;
    },
    validar_condonacion(value) {
      if (value.length == 1) {
        this.monto_condonar = 0;

        if (
          value[0].condonacion_obligacion.length > 0 &&
          this.usuario_condonacion
        ) {
          this.condonacion = true;
          this.monto_condonar = Math.ceil(value[0].saldo_capital);
          this.calcularCondonacion(this.monto_condonar, value[0]);
        } else {
          this.condonacion = false;
          this.condonacion_capital = 0;
          this.monto_condonar = 0;
          this.monto_max_condonar = 0;
        }
      } else {
        this.condonacion = false;
        this.condonacion_capital = 0;
        this.monto_condonar = 0;
        this.monto_max_condonar = 0;
      }
    },
    validarAsesorCondonacion(id) {
      this.usuario_condonacion = false;
      this.$store
        .dispatch("index", {
          endpoint: "usuario",
          params: { usuario_id: id, validar_condonacion: true },
        })
        .then((response) => {
          if (response.datos.length > 0) {
            this.usuario_condonacion = true;
          } else {
            this.usuario_condonacion = false;
            this.condonacion = false;
            this.condonacion_capital = 0;
            this.monto_condonar = 0;
            this.monto_max_condonar = 0;
          }
        })
        .catch((err) => {
          this.condonacion = false;
          this.condonacion_capital = 0;
          this.monto_condonar = 0;
          this.monto_max_condonar = 0;
          this.$notify({
            title: "Advertencia!",
            type: "danger",
            content: "No se ha podido validar el descuento de capital",
          });
          this.usuario_condonacion = false;
        });
    },
    validarAsesorInsolvencia(id) {
      this.insolvencia = false;
      this.$store
        .dispatch("index", {
          endpoint: "usuario",
          params: { usuario_id: id, insolvencia: true },
        })
        .then((response) => {
          if (response.datos.length > 0) {
            this.insolvencia = true;
          } else {
            this.insolvencia = false;
          }
        })
        .catch((err) => {
          this.insolvencia = false;
          this.$notify({
            title: "Advertencia!",
            type: "danger",
            content: "No se ha podido validar el descuento de capital",
          });
        });
    },
    calcularCondonacion(monto_condonar, obl) {
      if (this.usuario_condonacion) {
        let fecha = obl.informacion_adicional.fecha_ultimo_pago;

        const date1 = this.$moment();
        const date2 = this.$moment(fecha);

        const diffTime = this.$moment.duration(date1.diff(date2)).asDays();
        const diffDays = parseInt(diffTime);

        this.$store
          .dispatch("index", {
            endpoint: "altura_mora",
            params: { paginar: "false", rango_inicial: diffDays },
          })
          .then((response) => {
            if (response.datos.length > 0) {
              this.altura = response.datos[0];
              this.porcentaje_condonacion_capital =
                response.datos[0].porcentaje;
              this.condonacion_capital = this.monto_max_condonar = Math.ceil(
                monto_condonar * (response.datos[0].porcentaje / 100)
              );
            } else {
              this.condonacion = false;
              this.condonacion_capital = 0;
              this.monto_condonar = 0;
              this.monto_max_condonar = 0;
              this.$notify({
                title: "Advertencia!",
                type: "danger",
                content:
                  "No se encontraron alturas validas para descuento de capital",
              });
            }
          });
      }
    },
    validarPorcentaje() {
      if (this.usuario_condonacion) {
        if (this.porcentaje_condonacion_capital > this.altura.porcentaje) {
          this.porcentaje_condonacion_capital = this.altura.porcentaje;
          this.$notify({
            title: "Advertencia!",
            type: "danger",
            content:
              "El porcentaje maximo para el descuento de capital es de " +
              this.altura.porcentaje +
              " %",
          });
          this.condonacion_capital = Math.ceil(
            this.monto_condonar * (this.altura.porcentaje / 100)
          );
        } else {
          this.condonacion_capital = Math.ceil(
            this.monto_condonar * (this.porcentaje_condonacion_capital / 100)
          );
        }

        if (this.porcentaje_condonacion_capital < 0) {
          this.porcentaje_condonacion_capital = 0;
          this.$notify({
            title: "Advertencia!",
            type: "danger",
            content:
              "El porcentaje minimo para el descuento de capital es de " + 0 + " %",
          });
        }
      }
    },
    async guardarGestion(accion = "guardar") {
      this.saving = true;
      /*let hi = this.$moment(localStorage.inicioDateGestion).format(
        "YYYY-MM-DD HH:mm:ss"
      );*/
      //valida si que mensaje mostrar segun sub tipo de gestion
      var arrayaux = [5, 28, 30];
      if (
        confirm(
          !arrayaux.includes(this.sub_tipo_gestion_id)
            ? this.sub_tipo_gestion_id == 6
              ? this.validacionAcuerdo
                ? "¿Está seguro que desea cancelar el acuerdo de pago vigente y almacenar ésta gestión?"
                : "¿Está seguro que desea almacenar ésta gestión?"
              : "¿Está seguro que desea almacenar ésta gestión?"
            : "¿Está seguro que cuenta con los soportes para tipificar la obligación en " +
                this.sub_tipo_gestion_id +
                " ?"
        )
      ) {
        if (this.buttonDisabled) {
          this.saving = false;
          return false;
        }

        this.hora_fin = this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss");

        let gestion_obligacion = this.gestion_obligacion.map((o) => {
          return { obligacion_id: o.id };
        });

        let gestion = {
          gestion_obligacion: gestion_obligacion,
          causal_mora_id: this.causal_mora_id,
          hora_inicio: this.hora_inicio,
          hora_fin: this.hora_fin,
          tipo: this.tipo.id,
          sub_tipo_gestion_id: this.sub_tipo_gestion_id,
          observacion: this.observacion,
          origen: this.origen,
          deudor_id: this.deudor.id,
          telefono:
            this.origen == "Whatsapp entrada" ||
            this.origen == "Whatsapp salida"
              ? this.gestion.telefono
              : this.$store.getters["telefono"],
        };

        let saldo_cap = 0;

        this.obligaciones.forEach((value) => {
          if (value.id == gestion_obligacion[0].obligacion_id) {
            saldo_cap = value.saldo_capital;
          }
        });

        //

        if (
          this.sub_tipo_gestion_id == "6" ||
          this.sub_tipo_gestion_id == "12"
        ) {
          this.datosGestion.acuerdo_pago["estado"] = "vigente";
          this.datosGestion.acuerdo_pago["valor_compromiso"] = 0;
          this.datosGestion.acuerdo_pago["tipo"] = this.subtipo.descripcion;
          this.datosGestion.acuerdo_pago.fecha_primer_pago = this.$moment(
            this.fecha_primer_pago
          ).format("YYYY-MM-DD");
          gestion["acuerdo_pago"] = [this.datosGestion.acuerdo_pago];
          this.datosGestion.acuerdo_pago.deudor_id = this.deudor.id;
          this.datosGestion.acuerdo_pago.fecha_gestion = this.hora_fin;
        }

        if (this.condonacion) {
          if (this.condonacion_capital > this.monto_max_condonar) {
            this.$notify({
              title: "Advertencia!",
              type: "warning",
              content: "El saldo capital a descontar de capital es mayor al permitido",
              duration: 0,
            });
            this.saving = false;
            return false;
          } else {
            this.datosGestion.acuerdo_pago["condonacion_capital"] =
              this.condonacion_capital;
            this.datosGestion.acuerdo_pago["porcentaje_condonacion_capital"] =
              this.porcentaje_condonacion_capital == ""
                ? 0
                : this.porcentaje_condonacion_capital;
          }
        } else {
          this.datosGestion.acuerdo_pago["condonacion_capital"] = null;
          this.datosGestion.acuerdo_pago["porcentaje_condonacion_capital"] =
            null;
        }

        if (this.sub_tipo_gestion_id == "25") {
          //delete this.datosGestion.acuerdo_pago["fecha_primer_pago"];
          this.datosGestion.acuerdo_pago.fecha_primer_pago = this.$moment(
            this.fecha_primer_pago
          ).format("YYYY-MM-DD");
          this.datosGestion.acuerdo_pago["tipo"] = this.subtipo.descripcion;
          this.datosGestion.acuerdo_pago["monto_congelar"] = 0;
          this.datosGestion.acuerdo_pago["valor_cuota_inicial"] = 0;
          this.datosGestion.acuerdo_pago["cuotas"] = 0;
          this.datosGestion.acuerdo_pago["valor_cuota"] = 0;
          this.datosGestion.acuerdo_pago["estado"] = "vigente";
          delete this.datosGestion.acuerdo_pago["condonacion_capital"];
          delete this.datosGestion.acuerdo_pago[
            "porcentaje_condonacion_capital"
          ];

          gestion["acuerdo_pago"] = [this.datosGestion.acuerdo_pago];
          this.datosGestion.acuerdo_pago.deudor_id = this.deudor.id;
          this.datosGestion.acuerdo_pago.fecha_gestion = this.hora_fin;
        }

        if (
          this.sub_tipo_gestion_id == "32" ||
          this.sub_tipo_gestion_id == "34"
        ) {
          let pqrs = await this.enviarPQRS();
          if (pqrs != true) {
            this.saving = false;
            return false;
          }
        }

        if (this.subtipo.id == 24 && saldo_cap != 0) {
          this.$notify({
            title: "Advertencia!",
            type: "warning",
            content:
              "No se puede guardar la gestión ya que el saldo capital de la obligación no es 0.",
            duration: 0,
          });
          this.saving = false;
          return false;
        }

        this.observacionGocontact = this.datosGestion.gestion.observacion;

        if (this.validacionAcuerdo == true) {
          gestion["cancelar_acuerdos"] = true;
        }

        this.$store
          .dispatch("gestion/guardarGestion", gestion)
          .then((response) => {
            if (this.sub_tipo_gestion_id == "6") {
              let request = {};
              request.acuerdo = response.acuerdo_pago[0];
              request.destinatario = "Descarga local";

              this.descargarArchivo(request);
              this.$store
                .dispatch("gestion/enviarSMS", {
                  gestion: gestion,
                  acuerdo_pago: this.datosGestion.acuerdo_pago,
                  accion: this.sub_tipo_gestion_id,
                })
                .then(() => {
                  this.$notify({
                    title: "Envío de SMS",
                    type: "success",
                    content: "Se envío notificación vía SMS",
                  });
                  this.saving = false;
                })
                .catch((error) => {
                  this.$notify({
                    title: "Gestión",
                    type: "warning",
                    content: "No se pudo enviar notificación vía SMS",
                  });
                  this.saving = false;
                });
            }
            this.$notify({
              title: "Gestión",
              type: "success",
              content: "Se guardó la gestión satisfactoriamente",
            });
            this.inicializarVariablesGestion();
            this.saving = false;

            if (accion == "guardar_y_cerrar") {
              this.colgarLlamada();
              this.$router.push({ name: "home" });
            }
          })
          .catch((error) => {
            this.gestion_obligacion = [];
            this.acuerdo_pago = [];
            let errors = Object.values(error.data.errors);
            if (errors.length > 0) {
              errors.forEach((value, key) => {
                let contenido = value.join("\n");
                this.$notify({
                  title: "Error: ",
                  type: "warning",
                  content: contenido,
                  duration: 0,
                });
              });
            } else {
              this.$notify({
                title: "Advertencia!",
                type: "warning",
                content: error.data.errors
                  ? "Los datos dados no son válidos"
                  : "Se presentó un error guardando la gestión",
                duration: 0,
              });
            }

            this.saving = false;
          });
      } else {
        this.saving = false;
      }
      return false;
    },
    descargarArchivo(parametros) {
      try {
        this.$store
          .dispatch("store", {
            endpoint: "/utilidades/enviar_documento_acuerdo_pago",
            params: parametros,
            config: {
              responseType: "arraybuffer",
            },
          })
          .then((response) => {
            let nombre_archivo =
              this.deudor.identificacion +
              "_acuerdopago_" +
              this.dateTimeNow() +
              ".pdf";
            var blob = new Blob([response], {
              type: "application/pdf;charset=utf-8",
            });
            FileSaver.saveAs(blob, nombre_archivo);
            this.$notify({
              title: "Descarga correcta!",
              type: "success",
              content: "El archivo se ha descargado con exito.",
            });
          })
          .catch((error) => {
            console.log(error);
            this.$notify({
              title: "Error!",
              type: "warning",
              content:
                "Se presento un error a la hora de descargar el archivo.",
              duration: 0,
            });
          });
      } catch (error) {
        console.log(error);
      }
    },
    cerrarModal() {
      this.modal = false;
      this.mensaje_bloqueo = "";
    },
    abrirModal(
      diferencia_nit,
      bloqueo_gestion,
      sin_permiso_condonar,
      observaciones
    ) {
      let observacion = "";
      if (observaciones)
        observacion = ' - Observación: " ' + observaciones + '"';

      if (diferencia_nit) {
        this.mensaje_bloqueo =
          "Esta obligación no se encuentra asignada a su casa de cobranza." +
          observacion;
      } else if (bloqueo_gestion) {
        this.mensaje_bloqueo =
          "Esta obligación se encuentra bloqueada y no puede ser gestionada." +
          observacion;
      } else if (sin_permiso_condonar) {
        this.mensaje_bloqueo =
          "Usted no cuenta con permisos para descontar capital, por lo tanto no puede gestionar esta oblgiación." +
          observacion;
      }
      this.modal = true;
    },
    padZero(value) {
      return value < 10 ? "0" + value : value;
    },
    dateTimeNow() {
      var now = new Date();

      var year = now.getFullYear();
      var month = this.padZero(now.getMonth() + 1); // Adding 1 because months are zero-based
      var day = this.padZero(now.getDate());
      var hours = this.padZero(now.getHours());
      var minutes = this.padZero(now.getMinutes());
      var seconds = this.padZero(now.getSeconds());

      var formattedDateTime = `${year}_${month}_${day}_${hours}_${minutes}_${seconds}`;
      return formattedDateTime;
    },
    tipificarGestion() {
      this.$store.dispatch("vicidial/tipificarLlamada", {
        value: this.sub_tipo_gestion_id,
      });
    },
    colgarLlamadaGestion() {
      this.$store.dispatch("vicidial/colgarLlamada");
    },
    colgarLlamada() {
      // #colgar y tipificar wolkvox
      if (this.$store.getters["agent_id"]) {
        console.log("Wolkvox");
        this.$store
          .dispatch("wolkvox/colgarLlamada", {
            agent_id: this.$store.getters["agent_id"],
            subtipo: this.$store.getters["codigo_tipo_gestion"],
          })
          .then((response) => {
            console.log("wolkvox2--OK", response);
            this.$store.commit("CLEAR_AGENT_ID");
            this.$store.commit("CLEAR_TELEFONO");
          })
          .catch((error) => {
            // Manejar errores en la solicitud a la API
            console.log("wolkvox3-error", error);
          });
        this.$store.commit("CLEAR_AGENT_ID");
        this.$store.commit("CLEAR_TELEFONO");
      }
      // #colgar y tipificar go contact
      let marcador = this.$store.getters["user/marcador"];
      if (marcador === "gocontact") {
        if (this.$store.getters["uuid"])
          this.$store
            .dispatch("gocontact/colgarLlamada", {
              uuid: this.$store.getters["uuid"],
              ownerid: this.$store.getters["ownerid"],
              ownertype: this.$store.getters["ownerType"],
              subtipo: this.$store.getters["sub_tipo_gestion_name"],
              comments: this.observacionGocontact,
            })
            .then(() => {
              this.$store.commit("CLEAR_UUID");
              this.$store.commit("CLEAR_TELEFONO");
            });
      }
      // #colgar y tipificar vidicial
      if (marcador == "vicidial") {
        this.tipificarGestion();
        this.colgarLlamadaGestion();
      }
      // #colgar y tipificar Wolkvox
    },
    dpOnClose() {
      this.dia_pago = this.$moment(this.dia_pago).format("YYYY-MM-DD");
    },
    banco_abr(infoAdicional) {
      return infoAdicional.nombre_banco_br || infoAdicional.nombre_banco || "";
    },
    simular(way) {
      if (isNaN(this.monto_congelar) || this.monto_congelar <= 0) {
        alert("El monto a congelar no es válido");
        return false;
      }
      if (isNaN(this.valor_cuota_inicial) || this.valor_cuota_inicial < 0) {
        alert(
          "El valor de la cuota inicial debe ser igual o mayor a 0 y usted indió:" +
            this.valor_cuota_inicial
        );
        return false;
      }
      let monto_congelar = 0;
      switch (way) {
        case "numero_cuotas":
          if (
            isNaN(this.valor_cuota) ||
            this.valor_cuota == null ||
            this.valor_cuota < 0
          ) {
            alert("El valor de la cuota debe ser mayor a 0");
            return false;
          }
          let cuotas =
            (this.monto_congelar -
              this.condonacion_capital -
              this.valor_cuota_inicial) /
            this.valor_cuota;
          if (cuotas === Infinity) {
            alert(
              "Ocurrió un error al intentar calcular el numero de cuotas. Se calculó un valor infiníto"
            );
            return false;
          }
          monto_congelar =
            Math.round(cuotas) * this.valor_cuota +
            this.valor_cuota_inicial +
            this.condonacion_capital;

          if (!Number.isInteger(cuotas)) {
            if (
              !confirm(
                "El valor a diferir es: " +
                  (this.monto_congelar -
                    this.condonacion_capital -
                    this.valor_cuota_inicial) +
                  " \n" +
                  "El número de cuotas según el valor de la cuota es de: " +
                  cuotas +
                  "\n" +
                  "Sin embargo, el numero de cuotas no puede ser decimal, desea actualizar el numero de cuotas a " +
                  Math.round(cuotas) +
                  "? Esto hará que el monto a congelar cambie a: $" +
                  monto_congelar +
                  "\n ¿Está seguro que desea continuar?"
              )
            ) {
              return false;
            }
          }
          this.monto_congelar = monto_congelar;
          this.cuotas = Math.round(cuotas);
          return true;
          break;
        case "valor_cuota":
          if (
            isNaN(this.cuotas) ||
            this.cuotas == null ||
            this.cuotas < 0 ||
            this.cuotas > this.numero_maximo_cuotas
          ) {
            alert(
              "El el número de cuotas debe estar entre 1 y " +
                this.numero_maximo_cuotas
            );
            return false;
          }
          let valor_cuota =
            (this.monto_congelar -
              this.condonacion_capital -
              this.valor_cuota_inicial) /
            this.cuotas;
          let valor_cuota_redondeada =
            Math.ceil(valor_cuota / this.miles_a_redondear) *
            this.miles_a_redondear;
          monto_congelar =
            valor_cuota_redondeada * this.cuotas +
            this.valor_cuota_inicial +
            this.condonacion_capital;
          if (
            !confirm(
              "El valor a diferir es: $" +
                (this.monto_congelar -
                  this.condonacion_capital -
                  this.valor_cuota_inicial) +
                " \n" +
                "El valor de la cuota según el numero de cuotas es de: $" +
                valor_cuota +
                "\n" +
                "Despues de aplicar el redondeo por " +
                this.miles_a_redondear +
                " el valor de la cuota será de $" +
                valor_cuota_redondeada +
                "? Esto hará que el monto a congelar cambie a: $" +
                monto_congelar +
                "\n ¿Está seguro que desea continuar?"
            )
          ) {
            return false;
          }

          this.monto_congelar = monto_congelar;
          this.valor_cuota = valor_cuota_redondeada;
          return true;

          break;
      }
    },
    inicializarVariablesGestion() {
      this.$store.commit("gestion/SET_INIT_DATOS_GESTION", {
        gestion: {
          tipo: null,
          subtipo: null,
          causal_mora_id: null,
          observacion: "",
          origen: null,
          gestion_obligacion: [],
        },
        acuerdo_pago: {
          fecha_primer_pago: null,
          dia_pago: null,
          monto_congelar: null,
          valor_cuota_inicial: 0,
          cuotas: null,
          valor_cuota: null,
          valor_compromiso: 0,
        },
        pqrs: {
          asunto: "",
          tipo_pqrs: null,
          correo_notificacion: null,
        },
      });

      this.gestion.telefono = null;
    },
    async enviarPQRS() {
      let payload = {
        email_test: "jibanez@fga.com.co",
        asunto: this.asunto_pqrs,
        descripcion: this.descripcion_caso,
        tipo: this.tipo_pqrs,
        prioridad: "P2",
        cedula: this.deudor.identificacion,
        origen: "gestion",
        nombre: this.deudor.nombre,
        apellido: "",
        email: this.correo_notificacion,
      };
      let formData = new FormData();
      // formData.set('email_test', 'jibanez@fga.com.co');
      formData.set("asunto", this.asunto_pqrs);
      formData.set("descripcion", this.descripcion_caso);
      formData.set("tipo", this.tipo_pqrs);
      formData.set("prioridad", "P2");
      formData.set("cedula", this.deudor.identificacion);
      formData.set("origen", "gestion");
      formData.set("nombre", this.deudor.nombre);
      formData.set("apellido", "");
      formData.set("email", this.correo_notificacion);
      formData.set("tipo_publico", "2");

      if (
        this.origen == "Whatsapp entrada" ||
        this.origen == "Whatsapp salida"
      ) {
        formData.set("canal", "11");
      } else {
        formData.set("canal", "7");
      }

      try {
        let response = await this.$store
          .dispatch("store", {
            endpoint: "crm/reportar_novedad",
            params: formData,
          })
          .then((response) => {
            this.$notify({
              title: "Caso creado exitosamente",
              type: "success",
              duration: 0,
              content:
                "El codigo del caso registrado es: " +
                response.cases.case_number,
            });
          })
          .catch((err) => {
            this.$notify({
              title: "Error creando caso en CRM",
              type: "danger",
              content: "Ocurrió un error al intentar guardar el caso en CRM.",
            });
          });

        return true;
      } catch (err) {
        this.$notify({
          title: "Error creando caso en CRM",
          type: "danger",
          content: "Ocurrió un error al intentar guardar el caso en CRM.",
        });
        return false;
      }

      return false;
    },
    getAcuerdos() {
      this.$store.dispatch("deudor/refresh_acuerdos_pago", []);
      this.$store
        .dispatch("index", {
          endpoint: "acuerdo_pago",
          params: {
            deudor: this.deudor.identificacion,
            estado: "vigente",
            paginar: false,
          },
        })
        .then((response) => {
          if (response.datos.length > 0) {
            this.$store.dispatch(
              "deudor/refresh_acuerdos_pago",
              response.datos
            );
          }
        });
    },
    validacionAcuerdoVigente() {
      this.acuerdosxobligaciones = [];
      if (
        this.gestion_obligacion.length != 0 && this.tipo != null
          ? this.tipo.id == 2
          : false
      ) {
        for (let index = 0; index < this.gestion_obligacion.length; index++) {
          for (let i = 0; i < this.acuerdos_pago.length; i++) {
            if (
              this.acuerdos_pago[i]["obligacion_id"] ==
              this.gestion_obligacion[index]["id"]
            ) {
              let acuerdo_vigente_sel = this.acuerdos_pago[i];
              acuerdo_vigente_sel["codigo"] =
                this.gestion_obligacion[index]["codigo"];
              this.acuerdosxobligaciones.push(acuerdo_vigente_sel);
            }
          }
        }
        if (this.acuerdosxobligaciones.length > 0) {
          this.validacionAcuerdo = true;
        }
      } else {
        this.validacionAcuerdo = false;
      }
    },
  },
  watch: {
    tipo(tipo) {
      this.sub_tipo_gestion_id = null;
      this.subtipo = null;
      this.validacionAcuerdoVigente();
    },
    subtipo(subtipo) {
      this.sub_tipo_gestion_id = subtipo == null ? null : subtipo.id;
      if (subtipo) {
        this.$store.commit("SET_SUB_TIPO_GESTION_NAME", subtipo.descripcion);
        this.$store.commit(
          "SET_CODIGO_TIPO_GESTION",
          subtipo.descripcion.substring(0, 2).trim()
        );
      }
    },
    gestion_obligacion(gestion_obligacion) {
      this.validacionAcuerdoVigente();
    },
    check_insolvencia(check) {
      this.cuotas = null;
      if (check) {
        this.numero_maximo_cuotas = 99999999999999;
        this.valor_cuota_minima = 1;
      } else {
        this.numero_maximo_cuotas = 100;
        this.valor_cuota_minima = 10000;
      }
    },
  },
  mounted() {
    this.hora_inicio = this.$store.getters["gestion/inicioGestion"];
    this.$store.dispatch("tiposSubtipos/fetchTipos");
    this.$store.dispatch("tiposSubtipos/fetchSubTipos");
    this.condonacion = false;
    this.condonacion_capital = 0;
    this.monto_condonar = 0;
    this.monto_max_condonar = 0;
    this.validarAsesorCondonacion(this.$store.state.user.user.id);
    this.validarAsesorInsolvencia(this.$store.state.user.user.id);
    setTimeout(() => {
      this.getAcuerdos();
    }, 1000);
  },
};
</script>